import angular from 'angular';
import secureFileUploaderCompleteStageComponent from './secureFileUploaderCompleteStage.component';

let secureFileUploaderCompleteStageModule = angular.module('secureFileUploaderCompleteStage', []).component('secureFileUploaderCompleteStage', secureFileUploaderCompleteStageComponent);

export default secureFileUploaderCompleteStageModule;



// WEBPACK FOOTER //
// ./app/components/secureFileUploaderCompleteStage/secureFileUploaderCompleteStage.js